import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fill-blue",
  "use": "fill-blue-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"fill-blue\">\n  <rect width=\"30\" height=\"30\" fill=\"#009dff\" />\n  <path d=\"M14,14H9.333l1.789-1.789L8.874,9.979,9.979,8.874l2.232,2.248L14,9.333V14ZM4.667,14H0V9.333l1.789,1.789L4.021,8.874l1.1,1.105L2.878,12.211,4.665,14ZM9.979,5.125h0l-1.1-1.1,2.248-2.232L9.333,0H14V4.666L12.211,2.878,9.98,5.125Zm-5.958,0h0L1.789,2.878,0,4.666V0H4.667L2.878,1.789,5.126,4.021l-1.1,1.1Z\" transform=\"translate(8 8)\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fill-blue.svg
// module id = 1858
// module chunks = 0